import { get } from 'lodash'

/**
 * Odoo の応答本文からエラーの文を取り出す。無ければ `null`。
 *
 * ⚠️Odoo の `type='json'` ルートは**例外でも HTTP 200** を返し、理由を
 * 本文の `error`(JSON-RPC: `{error: {message, data: {message}}}`)に入れる。
 * axios は 200 を reject しないので、これを見ずに `res.data.result` だけを
 * 読むと `undefined` になり、画面は失敗を**別の言葉**に読み替える —
 * 「保管期間を過ぎている可能性があります」(ダウンロード)、
 * 「再開しました」(止まった日付の再開・成功通知!)など(2026-09-16)。
 *
 * ext_edwin の専用ルートはさらに `{result: {error}}` / `{errors}` の形でも
 * 失敗を返す(`controllers/edwin_linkage_settings.py` の冒頭の注記)。
 * どの形でも1本で読めるようにする。
 */
export function odooErrorMessage(payload: unknown): string | null {
  const errors = get(payload, 'errors')
  if (errors) {
    return Array.isArray(errors) ? errors.join('\n') : String(errors)
  }
  const error = get(payload, 'error')
  if (!error) return null
  if (typeof error === 'string') return error
  return (
    get(error, 'data.message') || get(error, 'message') || JSON.stringify(error)
  )
}
